/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import brStyles from './CartDropdownBrandRefresh.module.css';

/**
 * Brand-refresh upsell card — keyboard-accessible button inside list item.
 */
const CartDropdownBrandRefreshUpsellCard = ({ item, currencySymbol, arrowIcon, onSelect }) => (
  <li className={brStyles.upsellCardItem}>
    <button
      type="button"
      className={brStyles.upsellCard}
      onClick={() => onSelect(item)}
    >
      <div className={brStyles.upsellPhoto}>
        <img src={item.productImageSmall || item.productImage} alt={item.title} />
        <span className={brStyles.upsellGo} aria-hidden="true">
          <img src={arrowIcon} alt="" />
        </span>
      </div>
      <div className={brStyles.upsellDesc}>
        <span className={brStyles.upsellName}>{item.title}</span>
        <span className={brStyles.upsellPrice}>
          {`${currencySymbol}${item?.price?.toFixed(2)}`}
        </span>
      </div>
    </button>
  </li>
);

CartDropdownBrandRefreshUpsellCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    productImageSmall: PropTypes.string,
    productImage: PropTypes.string,
    price: PropTypes.number,
  }).isRequired,
  currencySymbol: PropTypes.string,
  arrowIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onSelect: PropTypes.func.isRequired,
};

CartDropdownBrandRefreshUpsellCard.defaultProps = {
  currencySymbol: '$',
};

export default CartDropdownBrandRefreshUpsellCard;
